"use strict";
// (C) 2019-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertWidget = exports.convertKpi = exports.convertVisualizationWidget = exports.convertFilterReference = void 0;
var tslib_1 = require("tslib");
var api_model_bear_1 = require("@gooddata/api-model-bear");
var sdk_model_1 = require("@gooddata/sdk-model");
var drills_1 = require("./drills");
var ReferenceConverter_1 = require("../ReferenceConverter");
var PropertiesConverter_1 = require("../PropertiesConverter");
exports.convertFilterReference = function (filterReference) {
    if (api_model_bear_1.GdcExtendedDateFilters.isDateFilterReference(filterReference)) {
        return {
            type: "dateFilterReference",
            dataSet: sdk_model_1.uriRef(filterReference.dateFilterReference.dataSet),
        };
    }
    return {
        type: "attributeFilterReference",
        displayForm: sdk_model_1.uriRef(filterReference.attributeFilterReference.displayForm),
    };
};
exports.convertVisualizationWidget = function (visualizationWidget) {
    var _a = visualizationWidget.visualizationWidget, _b = _a.content, visualization = _b.visualization, ignoreDashboardFilters = _b.ignoreDashboardFilters, dateDataSet = _b.dateDataSet, drills = _b.drills, references = _b.references, properties = _b.properties, configuration = _b.configuration, _c = _a.meta, identifier = _c.identifier, uri = _c.uri, title = _c.title, summary = _c.summary;
    var convertedProperties = ReferenceConverter_1.convertReferencesToUris({
        properties: PropertiesConverter_1.deserializeProperties(properties),
        references: references || {},
    }).properties;
    return tslib_1.__assign({ type: "insight", ref: sdk_model_1.uriRef(uri), identifier: identifier, uri: uri, title: title, description: summary, insight: sdk_model_1.uriRef(visualization), dateDataSet: dateDataSet ? sdk_model_1.uriRef(dateDataSet) : undefined, ignoreDashboardFilters: ignoreDashboardFilters
            ? ignoreDashboardFilters.map(exports.convertFilterReference)
            : [], drills: drills ? drills.map(drills_1.convertVisualizationWidgetDrill) : [], properties: convertedProperties }, (configuration ? { configuration: configuration } : {}));
};
exports.convertKpi = function (kpi) {
    var _a = kpi.kpi, content = _a.content, _b = _a.content, dateDataSet = _b.dateDataSet, ignoreDashboardFilters = _b.ignoreDashboardFilters, drillTo = _b.drillTo, configuration = _b.configuration, _c = _a.meta, identifier = _c.identifier, uri = _c.uri, title = _c.title, summary = _c.summary;
    return tslib_1.__assign(tslib_1.__assign({ type: "kpi", ref: sdk_model_1.uriRef(uri), identifier: identifier, uri: uri, title: title, description: summary, dateDataSet: dateDataSet ? sdk_model_1.uriRef(dateDataSet) : undefined, ignoreDashboardFilters: ignoreDashboardFilters
            ? ignoreDashboardFilters.map(exports.convertFilterReference)
            : [], drills: drillTo ? [drills_1.convertKpiDrill(kpi)] : [] }, (configuration ? { configuration: configuration } : {})), { kpi: api_model_bear_1.GdcKpi.isKpiContentWithoutComparison(content)
            ? {
                comparisonType: content.comparisonType,
                metric: sdk_model_1.uriRef(content.metric),
            }
            : {
                comparisonType: content.comparisonType,
                comparisonDirection: content.comparisonDirection,
                metric: sdk_model_1.uriRef(content.metric),
            } });
};
exports.convertWidget = function (widget) {
    if (api_model_bear_1.GdcKpi.isWrappedKpi(widget)) {
        return exports.convertKpi(widget);
    }
    return exports.convertVisualizationWidget(widget);
};
//# sourceMappingURL=widget.js.map